/**
 * This function checks if the value has only one zero before the dot
 */

export function isZeroBeforeDot(value: string) {
  if (value[1] !== '.' && value[1]) return value[0] === '0';
  return;
}
